import { Checkbox, Modal } from "antd";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

const WhatsAppDialog = ({
  whatsAppOpen,
  handleWhatsAppCancel,
  whatsAppCheck,
  setWhatsAppCheck,
}) => {
  return (
    <Modal
      className="wa-modal"
      title={<div className="wa-title">WhatsApp</div>}
      open={whatsAppOpen}
      onOk={handleWhatsAppCancel}
      closable={false}
      okText="OK"
      cancelButtonProps={{ style: { display: "none" } }}
    >
      {/* ---------- embedded styles (single file) ---------- */}
      <style>{`
        .wa-modal .ant-modal-content{padding:0;border-radius:18px;overflow:hidden}
        .wa-modal .ant-modal-header{margin:0;padding:0;background:transparent}
        .wa-modal .ant-modal-body{padding:14px;background:#eef1f8}
        .wa-modal .ant-modal-footer{margin:0;padding:4px 14px 14px;background:#eef1f8;display:flex}
        .wa-modal .ant-modal-footer .ant-btn{flex:1;height:42px;border-radius:12px;font-weight:800}
        .wa-modal .ant-modal-footer .ant-btn-primary{background:linear-gradient(135deg,#162566,#2a3c8f);border:0}

        .wa-title{background:linear-gradient(135deg,#128c7e,#25d366);color:#fff;font-weight:800;font-size:16px;text-align:center;padding:14px 12px;letter-spacing:.4px}

        .wa-hero{display:flex;flex-direction:column;align-items:center;text-align:center;gap:6px;padding:6px 0 12px}
        .wa-hero-ico{width:56px;height:56px;border-radius:50%;background:#25d366;color:#fff;display:flex;align-items:center;justify-content:center;box-shadow:0 6px 16px rgba(37,211,102,.4)}
        .wa-hero-ico svg{font-size:32px!important}
        .wa-hero-t{font-weight:800;font-size:15px;color:#162566}

        .wa-row{display:flex;align-items:center;gap:10px;background:#fff;border:1.5px solid #e1e6f4;border-radius:14px;padding:12px 14px;cursor:pointer;color:#162566;font-weight:700;font-size:14px;box-shadow:0 1px 4px rgba(0,0,0,.05);transition:all .15s}
        .wa-row.on{border-color:#25d366;background:linear-gradient(135deg,#f0fdf4,#dcfce7);box-shadow:0 3px 10px rgba(37,211,102,.25)}
      `}</style>

      <div className="wa-hero">
        <span className="wa-hero-ico">
          <WhatsAppIcon />
        </span>
        <div className="wa-hero-t">Send bill on WhatsApp</div>
      </div>

      <div
        className={`wa-row ${whatsAppCheck ? "on" : ""}`}
        onClick={() => {
          if (whatsAppCheck === true) {
            setWhatsAppCheck(false);
          } else {
            setWhatsAppCheck(true);
          }
        }}
      >
        <Checkbox
          checked={whatsAppCheck}
          onChange={(e) => setWhatsAppCheck(e.target.checked)}
        />
        <span>Are you sure you want to send WhatsApp?</span>
      </div>
    </Modal>
  );
};

export default WhatsAppDialog;